import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import Help from '../../../generics/help';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../../generics/modal_person_search';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class SentPatient extends Component{
	constructor(props){
		super(props);

		//this.searching = this.searching.bind(this);		
		this.setTable = this.setTable.bind(this);
		this.updateState = this.updateState.bind(this);
		this.person_search = this.person_search.bind(this);

		this.state = {
			health_facilities_id:"",
	
			columns:[
				{title:'Fecha Envio'},
				{title:'No. Unidad'},
				{title:'Componente'},				
				{title:'Grupo & RH'},
				{title:'Hospital'},
				{title:'Servicio'},
			],
			filename:"Reporte Envios a Paciente",
			options:[],
			listado:[],
			total_comp:[],
			date_hour:"",
			patient:"",

			isLoading:false,
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		this.setTable();
	}

	setTable(){
		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

						doc.content.splice(2, 0, {
							columns:[
								{text: 'Fecha de emisión '+this.state.date_hour, width:"25%"},
								{text: this.state.patient, bold:1}
							],
							margin:[10,0,0,10] 
						});	

						doc.content[3].table.widths=["10%","10%","25%","10%","30%", "15%"];

						this.state.total_comp.map((t, i)=>(
							doc.content.push({
								text: t.text+': '+' '+t.num,
								bold: 1,
								margin: [10,0,0,0]
							})
						))

						doc.content.push({
							text: 'TOTALES:  '+' '+this.state.listado.length,
							bold: 1,
							margin: [10,0,0,0]
						})

						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false

		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}


	_handleSearch = (query) => {
	    this.setState({isLoading: true});

		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				for (var i = 0; i < response.length; i++) {

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
											+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}


					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}
					
					response[i].id = response[i].patient_id;
				};
				this.setState({
					isLoading: false,
			     	options: response
			    });

			    setTimeout(()=>{
			    	if(this.modal_person_search.state.show){
			    		var id = '';
			    		this.modal_person_search.state.list.map((p)=>{
			    			if(p.check){
			    				id = p.person_id;
			    			}
			    		});

			    		var index = this.state.options.findIndex(obj => 
			    			 parseInt(obj.person.id) === parseInt(id)
			    		);

			    		if(index !== -1){
			    			this.updateState([this.state.options[index]]);
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}else{
			    			swal('Información', 'El paciente seleccionado ya se encuentra en el listado', 'info')
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}
			    	}
			    	
			    }, 500);
			})
	}

	updateState(values) {
	    let value = '';
	    if (values.length > 0) {
	      	value = values[0];

	      	this._typeahead.getInstance().blur();

	      	this.props.waiting.handleShow('Cargando...');
	      	fetch(Config.default.apiGateway.URL+'reports/delivered_by_patient?patient_id='+
	      		value.id+'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{ 
				method: 'post',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(result) {
	                swal('¡Error', result, 'error');
	              });
	            }})
			.then(response => {
				if(response !== undefined){
					var list = [];
					response.res.map((res)=>{
						list.push([
							moment(res.delivered_date).format('DD/MM/YYYY HH:mm'),
							res.unit_number,
							res.component,
							res.group_rh,
							res.center_name,
							res.health_services
						])						
					})

					this.setState({
						listado:list,
						patient:values[0].lastname1+' '+values[0].lastname2+' '+values[0].names,
						total_comp:response.total_components
					});
					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
				}
			});

	    }
	}

	person_search(){
		this.modal_person_search.handleShow('Paciente','patients');
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Paciente ->
					Envios a Paciente
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_patient_delivered"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 form-group">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									
									<div className="col-xs-12">
										<div className="col-xs-12 col-sm-7">
											<span className="span-min">{t('content.generics.buttons.search')}</span>
									        <AsyncTypeahead
									          	labelKey={(option) => `${option.names}`}
									          	minLength={3}
									          	name="patient"
									          	id="patient"
									          	onSearch={this._handleSearch}
									          	placeholder="Buscar por apellidos más nombre o número de documento..."
									          	options={this.state.options}
									          	onChange={this.updateState}
									          	ref={ref => this._typeahead = ref}
									          	useCache={false}
									          	isLoading={this.state.isLoading}
									          	delay={600}
									          	paginationText="Mostrar mas resultados..."
									        />
										</div>

										<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
											<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
												onClick={this.person_search}/>
										</div>

										<div className="col-xs-12 col-sm-4" style={{marginTop:'20px'}}>
											<span style={{marginLeft:"5px"}}>
												Fecha de emisión: 
												<b style={{marginLeft:"5px"}}>{this.state.date_hour}</b>
											</span>
										</div>
									</div>
									
								</div>
								
								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>

								<div className="col-xs-12">
									{this.state.total_comp.map((t, i)=>(
										<div key={i}>
											<label>
												{t.text+': '}
											</label>
											<span style={{marginLeft:'8px'}}>{' '+t.num}</span>
										</div>
									))}
								</div>
								<div className="col-xs-12">
									<label>TOTALES: </label>
									<span style={{marginLeft:'8px'}}>{' '+this.state.listado.length}</span>
								</div>
								
							</div>
						</form>
					</div>
				</div>

				<ModalPersonSearch {...this.props} 
					waiting={this.props.waiting} 
					updatePerson={this.updateState} 
					onRef={ref => (this.modal_person_search = ref)} 
					search={this.updateState}
					persons={this.state.options}
				/>
			</div>
		)
	}
}

export default translate('translations') (SentPatient);